import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { submit as formSubmit, reduxForm, Field } from 'redux-form'
import { Dropdown } from 'semantic-ui-react'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import { ComponentContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKButton from 'shared/LKButton'

import { NodeDropdownWrapperProps } from '../../types.LoanDetails'
import { updateNodeID } from 'src/store/loan'

const getDropDownOnChange =
  (storeOnChange) =>
  (e, { value }) =>
    storeOnChange(value)

const Component = ({ input: { value, onChange }, options }) => (
  <ComponentContainer dropdown style={{ width: 'auto', float: 'left' }}>
    <Dropdown button search selection options={options} value={value} onChange={getDropDownOnChange(onChange)} />
  </ComponentContainer>
)

const formContainer = reduxForm({
  destroyOnUnmount: false,
  onSubmit: ({ node }, dispatch, { keyByID, ID, hash }) => {
    // return new Promise((resolve, reject) => {
    //   dispatch(
    //     fetchSFM({
    //       instanceName: keyByID,
    //       callApi: Loan.updateNodeID,
    //       callApiArgs: [node, ID, hash],
    //       resolve,
    //       reject,
    //     }),
    //   )
    // })

    //UPDATED API REQUEST loan_oper_api page: nodeupdate
    return dispatch(
      updateNodeID({
        LoanID: ID,
        HashSum_LoanID_: hash,
        NodeID: node,
      }),
    )
  },
})

//@ts-ignore
const NodeDropdown = formContainer(({ handleSubmit, options, form, keyByID }) => {
  const dispatch = useDispatch()

  // open confirm modal
  function handleClick() {
    dispatch(LKModalActions.openConfirmation('nodeModal'))
  }

  function handleConfirm() {
    dispatch(formSubmit(form))
  }

  return (
    <div>
      <LKModal.Confirmation name="nodeModal" onConfirm={handleConfirm} />

      <form onSubmit={handleSubmit}>
        <Field name="node" component={Component} options={options} />

        <LKButton alias="save" onClick={handleClick} permission="EDIT_NODE_LOAN" />
      </form>
    </div>
  )
})

const NodeDropdownWrapper: FC<NodeDropdownWrapperProps> = (props) => {
  const { ID, initialValue } = props
  const keyByID = `LoanDetailsOther-${ID}-NodeDropdown`

  return <NodeDropdown {...props} initialValues={{ node: initialValue }} form={keyByID} keyByID={keyByID} />
}

export default NodeDropdownWrapper
